<!--
 * @Date: 2023-01-28 12:08:36
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2023-02-13 10:11:51
 * @FilePath: \nicee-web-tw\src\activities\spring-festival\finally.vue
 * @Description: 决赛阶段
-->
<template>
  <div class="finally">
    <Chat
      :activityData="activityData"
      :rankList="rankList"
      @refresh="refresh"
    ></Chat>
    <div class="main">
      <div class="content">
        <img class="img-header" src="./images/finally-header.png" alt="" />
        <div class="rules-box">
          <div class="jewel-title">
            <img class="jewel" src="./images/jewel.png" alt="" />
            <span>決賽活動規則</span>
          </div>
          <div class="content-title">
            -活动時間：2/09 0:00 -2/10 23:59:59<br />
            -特殊活动時間：2/09 20:00-22:00 &nbsp;2/10 20:00-22:00
          </div>
          <p class="content">
            -
            活動規則：由初賽階段入圍的8名陪玩師在2月9號、2月10號20:00在語音房進行比賽，在特殊活動時間內陪玩師在語音房中所獲得的火力值都會在原有的基礎上雙倍計算；在正常的活動時間內陪玩師仍可正常積累火力值，截止到2月10號23:59:59點活動正常結束，火力值計算將不會再進行更新
          </p>
          <div class="reward">
            - 活動獎勵：活動獎勵會在活動結束後由客服聯繫對應獲獎用戶進行發放
          </div>
          <div class="illustrate">
            -
            特殊說明：活動結束後工作人員需要將比賽積分積累情況進行複核，最終結果將於2月11號進行公示
          </div>
        </div>
        <div class="jewel-title rank-list-title">
          <img class="jewel" src="./images/jewel.png" alt="" />
          <span>盛典火力榜</span>
        </div>
        <div class="rank-list">
          <div
            class="rank-list-item"
            v-for="(item, index) of rankList"
            :key="item.userUuid"
            @click="toPlayerDetail(item)"
          >
            <div class="img-box">
              <img
                src="./images/finally-rank-bg.png"
                class="avatar-border"
                alt=""
              />
              <img :src="item.avatarUrl" alt="" class="avatar" />
            </div>
            <span>
              {{ item.nickname }}
            </span>
            <span> uid: {{ item.userUuid }} </span>
            <span class="user-fire">
              <img src="./images/fire.png" alt="" />
              火力值：{{ formatScore(item.score, index) }}
            </span>
          </div>
        </div>
        <div class="my-rank" v-if="isPlayer">
          <div>
            <span>
              距离排名上一位陪玩师差距：{{
                appendInfo.NewYearStage3EndDateNeedAmount
              }}火力值
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Chat from './chat.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Finally',
  components: {
    Chat
  },
  props: {
    activityData: {
      typeof: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      selectedPlayer: null
    };
  },
  watch: {},
  computed: {
    ...mapGetters([
      'userInfo'
      // 'masterInfo'
    ]),
    //獲獎排名
    rankList() {
      try {
        return this.activityData.appendInfo.NewYearStage3EndDate || [];
      } catch (error) {
        return [];
      }
    },
    appendInfo() {
      try {
        return this.activityData.appendInfo || {};
      } catch (error) {
        return {};
      }
    },
    // 是B端用户
    isPlayer() {
      return this.userInfo && this.userInfo.userKind === 'Player';
    }
  },
  methods: {
    // 查看陪玩師詳情
    toPlayerDetail(userInfo) {
      if (userInfo && userInfo.userUuid) {
        this.$router.push({
          path: `/player-detail/${userInfo.userUuid}`
        });
      }
    },
    formatScore(score, index) {
      // 活動結束了，寫死123名的火力值
      if (index === 0) {
        return '52.2萬';
      }
      if (index === 1) {
        return '47.3萬';
      }
      if (index === 2) {
        return '20.1萬';
      }
      if (score) {
        const num = Number(score);
        if (num > 9999) {
          return (num / 10000).toFixed(1) + '萬';
        } else {
          return num;
        }
      } else {
        return 0;
      }
    },
    refresh() {
      this.$emit('refresh');
    }
  }
};
</script>
<style lang="scss" scoped>
.finally {
  > .main {
    font-size: 1.67rem;
    color: #e9cc95;
    width: 100.08rem;
    margin-top: 9.75rem;
    margin-bottom: 9.92rem;
    position: relative;
    background: #371c04;
    border: 1px solid #eabf7c;
    border-radius: 2rem;
    padding-bottom: 5.83rem;

    .img-header {
      position: absolute;
      left: 50%;
      top: 0;
      transform: translate(-50%, -50%);
      width: 27.92rem;
      height: 6.92rem;
    }

    .jewel-title {
      display: flex;
      align-items: center;
      margin-bottom: 2.33rem;
      font-size: 2.5rem;
      .jewel {
        width: 1.67rem;
        margin-right: 0.75rem;
      }
    }
    .rules-box {
      padding: 0 6.42rem;
      margin-top: 8.75rem;
      padding-bottom: 0;
      line-height: 2rem;

      .content-title {
        color: #fdd241;
        margin-bottom: 2.33rem;
        // margin-top: 26px;
        margin-left: 2.6rem;
      }
      .content {
        font-size: 1.67rem;
        margin-left: 2.6rem;
      }
    }

    .rank-list-title {
      padding-left: 6.42rem;
      margin-bottom: 0;
    }

    .reward {
      margin: 3.42rem 0 0 2.6rem;
    }

    .illustrate {
      margin: 3.42rem 0 6.33rem 2.6rem;
    }

    .rank-list {
      // margin-left: -18px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .rank-list-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: 0.58rem;
        flex: none;
        line-height: 2rem;
        margin-top: 4.83rem;
        width: 21.08rem;
        text-align: center;

        .img-box {
          width: 21.08rem;
          height: 37.5rem;
          position: relative;
          margin-bottom: 2.08rem;
          .avatar-border {
            width: 100%;
            height: 100%;
            position: absolute;
          }
          .avatar {
            width: 16.58rem;
            height: 28rem;
            margin: 5.67rem 2.67rem 0 2.33rem;
            object-fit: cover;
            border-bottom-left-radius: 50px;
            border-bottom-right-radius: 50px;
          }
        }
        .user-fire {
          img {
            width: 1.75rem;
            height: 2.83rem;
          }
        }
      }
    }

    .my-rank {
      display: flex;
      justify-content: center;
      margin-top: 2.5rem;
      > div {
        height: 5.42rem;
        background: #613204;
        border: 1px solid #f8b151;
        border-radius: 1rem;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        line-height: 2rem;
        padding: 0 2.58rem;
      }
    }
  }
}
</style>
